import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import "react-toastify/dist/ReactToastify.css";

/**
 * AdminLayout — root visual frame for all admin pages.
 *
 * Layout: Sidebar on the left (240px fixed), main column with a top bar
 * and the route `<Outlet />`. ToastContainer mounted here so any
 * ported module's toast calls are visible across the whole app.
 */
export function AdminLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}
